import React, { useState, useCallback } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
//import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';
import metadata from './AgentSignupLandingpage.metadata.json5';
//import metadata from './Agentsignup.metadata.json5';

import Agentsignupcomponent from 'gw-portals-login-react/SasriaAdminComponent/Agentsignupcomponent';
import SasriaAgentSignupPageTemplate from './template/SasriaAgentSignupPageTemplate';



const { applicationDetails } = appConfig;


function Agentsignup() {
    const resolvers = {
        resolveComponentMap: {
            agentsignupcomponent : Agentsignupcomponent
        }
    };
    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,resolvers);
    // return (
    //     <SasriaAgentSignupPageTemplate
    //         applicationName={applicationDetails.applicationName}
    //         applicationLogo={applicationDetails.applicationLogo}
    //         contentToRender={renderedContentFromMetadata}
    //     />
    // );

    return <div>{renderContentFromMetadata(metadata.pageContent, resolvers)}</div>;
}


export default Agentsignup;
